import packageInfo from '../../package.json';

export default packageInfo.version;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/version/index.js
// module id = null
// module chunks = 